import {gql} from '@apollo/client';

export const UPSERT_BANK_ACCOUNT = gql`
  mutation UpsertBankAccount(
    $accountId: UUID
    $contactId: UUID
    $providerId: UUID
    $accountName: String
    $accountNumber: String
    $sortCode: String
    $status: String
  ) {
    upsertBankAccount(
      accountId: $accountId
      contactId: $contactId
      providerId: $providerId
      accountName: $accountName
      accountNumber: $accountNumber
      sortCode: $sortCode
      status: $status
    ) {
      ok
      errors
      bankAccount {
        id
      }
    }
  }
`;

export const SUBMIT_BANK_ACCOUNT = gql`
  mutation SubmitBankAccount($bankAccountId: UUID!) {
    submitBankAccount(bankAccountId: $bankAccountId) {
      ok
      errors
      bankAccount {
        id
        status
      }
    }
  }
`;
